import Vue from 'vue';
import utils from '../../services/utils';
import {
  AUTH_REQUEST,
  AUTH_ERROR,
  AUTH_SUCCESS,
  AUTH_LOGOUT,
} from '../actions/auth';
import { BASE_URL, LOGIN, M_POST } from '../../utils/api';
/* eslint-disable */
const state = {
  token: utils.getUserPersistent().token || '',
  username: '',
  wallet: '',
  status: '',
  hasLoadedOnce: false,
}

const getters = {
  isAuthenticated: state => !!state.token,
  authStatus: state => state.status,
  authUsername: state => state.username,
  authWallet: state => state.wallet
}

const actions = {
  [AUTH_REQUEST]: ({commit, dispatch}, user) => {
    return new Promise((resolve, reject) => { // The Promise used for router redirect in login
      commit(AUTH_REQUEST)
      Vue.axios({url: BASE_URL + LOGIN, data: user, method: M_POST })
        .then(resp => {
          let result = resp.data
          if (result.status.code === 0) {
            const token = result.data.token
            const username = result.data.user.username
            const wallet = result.data.user.wallet.balance
            // let loginTime = new Date()
            // localStorage.setItem('ambgames-user-authenticate', JSON.stringify(result.data))
            // localStorage.setItem('timestamp', loginTime)
            Vue.prototype.$session.start()
            Vue.prototype.$session.set('ambgames-user-authenticate', JSON.stringify(result.data))
            Vue.axios.defaults.headers.common['Authorization'] = 'Bearer ' + token
            commit(AUTH_SUCCESS, token, username, wallet)
            resolve(resp)
          } else {
            throw result.status.message
          }
        })
        .catch(err => {
          commit(AUTH_ERROR, err)
          delete Vue.axios.defaults.headers.common['Authorization']
          Vue.prototype.$session.destroy()
          reject(err)
        })
    })
  },
  // [AUTH_LOGOUT]: ({commit, dispatch}) => {
  //   return new Promise((resolve, reject) => {
  //     commit(AUTH_LOGOUT)
  //     localStorage.removeItem('ambgames-user-authenticate')
  //     localStorage.removeItem('timestamp')
  //     delete Vue.axios.defaults.headers.common['Authorization']
  //     resolve()
  //   })
  // }
}

const mutations = {
  [AUTH_REQUEST]: (state) => {
    state.status = 'loading'
  },
  [AUTH_SUCCESS]: (state, token, username, wallet) => {
    state.status = 'success'
    state.token = token
    state.username = username
    state.wallet = wallet
  },
  [AUTH_ERROR]: (state) => {
    state.status = 'error'
  },
  [AUTH_LOGOUT]: (state) => {
    state.token = ''
  }
}

export default {
  state,
  getters,
  actions,
  mutations,
}
